import React, { Component } from "react";
import Auth from "../Auth";
import { Link, withRouter } from "react-router-dom";
import { Button } from "react-bootstrap";
import { defaultMainPath } from "../security/routes";
import WorkspacePageContext from "./WorkspacePageContext";
export class SignOut extends Component {
  static contextType = WorkspacePageContext;

  redirect = () => {
    const { history } = this.props;
    if (history) history.push("/");
  };

  logout() {
    Auth.SignOut();
  }

  handleLogOut = async (e) => {
    e.preventDefault();
    await Auth.SignOut();
    this.redirect();
  };
  render() {
    if (this.context) return null;
    return (
      <div>
        <div className=" addinfo d-flex">
          {" "}
          <ul className="header-actions">
            <li className="dropdown">
              <div id="userSettings" className="user">
                <Link to={defaultMainPath()}>
                  <button className="profile">
                    <i className="fas fa-user-alt"></i>
                  </button>
                </Link>
              </div>
              <div
                className="dropdown-menu dropdown-menu-right"
                aria-labelledby="userSettings"
              >
                <div className="header-profile-actions">
                  <li className="iconlogout">
                    <span>
                      <i class="far fa-arrow-alt-circle-right"></i>
                      {"   "}
                    </span>
                    <Button className="logout" onClick={this.handleLogOut}>
                      Sign out
                    </Button>
                  </li>
                  <li className="account-password-link">
                    <Link to="/ChangePassword">Change Password</Link>
                  </li>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default withRouter(SignOut);
